import moment from "moment";
import { getRandomInt } from "services/mock-api/data";

export const randomErrorOccurence = (message?: string) => {
  if (!message) message = "An error has occured unexpectedly";
  const isError = getRandomInt(0, 50) < 10;
  if (isError) throw new Error(message);
  return;
};

export const getDateAfter = (value: string): string => {
  const date = moment(value);
  if (date.toISOString() === null) throw Error("invalid date format");
  const newDate = date.add(getRandomInt(1, 10), "days");
  return newDate.toISOString();
};

export const getDateBefore = (value: string): string => {
  const date = moment(value);
  if (date.toISOString() === null) throw Error("invalid date format");
  const newDate = date.add(getRandomInt(-10, -1), "days");
  return newDate.toISOString();
};
